<div id="map">
  <div class="map-display">
    @if(showAltitude()) {
      <app-text id="altitude" class="is-family-medium altitude-text" [text]="'▵ ' + altitude()" />
    }
    @if(showGeolocateButton()) {
      <app-icon #geolocateButton class="is-align-end text-24 geolocate-button" [name]="'tracking'" />
    }
  </div>
</div>
